import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

const SignInPage = lazy(() => import('src/pages/auth/sign-in'));
const AuthErrorPage = lazy(() => import('src/pages/auth/error'));

export const authRoutes: RouteObject[] = [
  {
    path: '/sign-in',
    element: (
      <Suspense fallback={null}>
        <SignInPage />
      </Suspense>
    ),
  },
  {
    path: '/auth/error',
    element: (
      <Suspense fallback={null}>
        <AuthErrorPage />
      </Suspense>
    ),
  },
];
